/* @flow */
/* eslint-disable max-statements */
import produce from 'immer'
import { validation } from './Steps9.consts'

export default function reducer(state, action: any) {
  const initialState = action.__initialData.defaultProps
  return produce(state, draft => {
    switch (action.type) {
      case 'REMOVE_BLOCK': {
        const { idx } = action.value
        draft.blocks.splice(idx, 1)
        break
      }
      case 'ADD_BLOCK':
        if (state.blocks.length === validation.blocks.max) {
          return
        }
        draft.blocks.push(initialState.blocks[0])
        break
      case 'CHANGE_BLOCK_TITLE':
        const { newBlockTitle, idx: titleIdx } = action.value
        draft.blocks[titleIdx].blockTitle = newBlockTitle
        break
      case 'CHANGE_BLOCK_PARAGRAPH': {
        const { newBlockParagraph, idx } = action.value
        draft.blocks[idx].blockParagraph = newBlockParagraph
        break
      }
      case 'REMOVE_BACKGROUND_IMAGE':
        draft.backgroundImgUrl = ''
        draft.backgroundImgDimensions = {}
        break
      case 'CHANGE_BACKGROUND_IMAGE':
        const { url, dimensions } = action.value
        draft.backgroundImgUrl = url
        draft.backgroundImgDimensions = dimensions
        break
      case 'CHANGE_BG_OVERLAY_TRANSPARENCY':
        draft.bgOverlayTransparency = action.value
        break
      case 'CHANGE_BLOCK_TITLE_ALIGNMENT': {
        const { alignment, idx } = action.value
        draft.blocks[idx].blockTitleAlignment = alignment
        break
      }
      case 'CHANGE_BLOCK_PARAGRAPH_ALIGNMENT': {
        const { alignment, idx } = action.value
        draft.blocks[idx].blockParagraphAlignment = alignment
        break
      }
    }
  })
}
